import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {AppConfig} from '../../network/app_config';
import {AppConfigQuery} from '../../gql/pwa/graphql';

interface State extends AppConfigQuery {}

export const fetchAppConfig = createAsyncThunk('appConfig/fetchConfig', async () => {
    const result = await AppConfig.appConfig();
    return result.data;
});

export const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAppConfig.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(fetchAppConfig.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.appconfig = action.payload.appconfig;
            state.locations = action.payload.locations;
            state.leadProviders = action.payload.leadProviders;
            state.organisation = action.payload.organisation;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchAppConfig.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
